export const DOMAIN = 'dsarTypes';
